module.exports = __webpack_public_path__ + "static/media/26_B.18d297cf.png";